import { highlightClips } from '@/mocks/animeData';

export default function HighlightClips() {
  return (
    <section id="clips" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
            <i className="ri-clapperboard-line"></i>高能剪辑
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">高能片段，一刷再刷</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
            精选观众最爱的高能片段剪辑，把最炸的几十秒单独拎出来给你。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {highlightClips.map((clip) => (
            <article
              key={clip.title}
              className="group overflow-hidden rounded-3xl bg-background-50"
            >
              <div className="relative h-52 overflow-hidden md:h-44">
                <img
                  src={clip.image}
                  alt={`高能片段：${clip.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <button
                  type="button"
                  aria-label={`播放：${clip.title}`}
                  className="absolute inset-0 flex items-center justify-center bg-foreground-950/25 opacity-0 transition-opacity group-hover:opacity-100"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className="ri-play-fill text-xl"></i>
                  </span>
                </button>
                <span className="absolute bottom-3 right-3 whitespace-nowrap rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] text-foreground-50">
                  {clip.duration}
                </span>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between gap-2">
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-bold text-secondary-900">
                    {clip.episode}
                  </span>
                  <span className="inline-flex items-center gap-1 text-[11px] text-foreground-600">
                    <i className="ri-eye-line"></i>{clip.views}
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-base text-foreground-950">{clip.title}</h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}